<template>
  <div
    v-if="record"
    class="container"
  >
    <div class="row">
      <div class="col-xs-12">
        <h1>
          Vehicle Documents
        </h1>
        <!-- eslint-disable vue/no-v-html -->
        <p
          v-if="record.customer.car_registration"
          class="record-label"
          v-html="`Vehicle registration: ${record.customer.car_registration}`"
        />
        <p
          v-if="record.customer.vehicle_stock_number"
          class="record-label"
          v-html="`Vehicle stock number: ${record.customer.vehicle_stock_number}`"
        />
        <!-- eslint-enable vue/no-v-html -->

        <request-box-view
          v-if="showRequestBox && serviceLevelPaid"
          :requests="outstandingRequestDocuments"
          class="request-box"
          @updated="fetchRecord"
        />

        <div
          v-if="signedDocument"
          class="alert alert-success"
          role="alert"
        >
          {{ signedDocument.template_document.name || 'Document' }} signed, thank you.
        </div>

        <div class="panel panel-default">
          <ul class="list-group">
            <li
              v-if="record.documents.length"
              class="list-group-item active"
            >
              Vehicle Documents
            </li>
            <li
              v-for="doc in record.documents"
              :key="`doc${doc.id}`"
              class="list-group-item"
              :class="{ disabled: !doc.is_stored }"
            >
              <document-view
                :deal-id="record.id"
                :disabled="!doc.is_stored || doc.temporarilyDisabled"
                :doc="doc"
                :signature-data="signatureData"
                @document-signed="pollRecord(2000, doc)"
                @view="stopPolling"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import DocumentView from './record/document.vue';
// import CustomerView from './profile/customer.vue';
import RequestBoxView from '../common/requestBox.vue';

export default {
  components: {
    // CustomerView,
    DocumentView,
    RequestBoxView,
  },
  props: {
    recordId: {
      type: Number,
      default: null,
    },
    rejectionCodes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      record: null,
      signedDocument: null,
      // We use this as we want to decide if we show it on page load and not hide
      // when the last request is completed.
      pollRecordTimeout: null,
      pollRecordTimeoutDelay: 2000,
      pollRecordTimeoutMaxDelay: 15000,
    };
  },
  computed: {
    outstandingRequestDocuments() {
      return _.filter(
        this.record.document_requests,
        (request) => !request.is_complete,
      );
    },
    showRequestBox() {
      return this.outstandingRequestDocuments.length > 0;
    },
    signatureData() {
      const keys = ['current_ip', 'legal_disclaimer'];
      return keys.reduce((obj, k) => {
        obj[k] = this.record[k]; // eslint-disable-line no-param-reassign
        return obj;
      }, {});
    },
  },
  mounted() {
    this.pollRecord();
  },
  methods: {
    pollRecord(delay = this.pollRecordTimeoutMaxDelay, docToDisable = null) {
      if (docToDisable) docToDisable.temporarilyDisabled = true; // eslint-disable-line no-param-reassign
      this.fetchRecord().then(() => {
        this.pollRecordTimeout = setTimeout(() => {
          const nextDelay = Math.min(delay * 2, this.pollRecordTimeoutMaxDelay);
          this.pollRecord(nextDelay);
        }, delay);
      });
    },
    stopPolling() {
      clearTimeout(this.pollRecordTimeout);
    },
    fetchRecord() {
      const app = this;
      return app.ApiService.fetchRecord(app.recordId)
        .then((response) => {
          app.record = response;
        })
        .catch((error) => {
          app.alertBox({ type: 'error', message: error }).then(() => {
            app.records = [];
          }).catch();
        });
    },
  },
};
</script>

<style lang="scss">
.request-box {
  margin-bottom: 2em;
}
</style>
